module.exports = __webpack_public_path__ + "img/ai_hi.443ed2da.png";